module.exports = __webpack_public_path__ + "img/edge_activites_ski_nautique.191b4777.svg";